<template>
  <div
    ref="panel"
    class="color-panel"
    :style="{
      background: image?`url(${image}) no-repeat 0 0 / 100% 100%`: ''
    }"
  >
    <div
      class="cursor"
      :style="{top:cursorTop + 'px',left:cursorLeft +'px'}"
    >
      <div />
    </div>
  </div>
</template>

<script>
import draggable from '../draggable';
import { CxCyUtils } from '../CxCyUtils'
import { ValueToCxCy } from '@/utils/colors.js'

export default {
  props: {
    color: {
      required: true
    },
    config:{
      type:Object,
      required:true
    },
    image:{
      type:String,
      default:''
    }
  },
  data () {
    return {
      cxCyUtils:null,
      background:null,
      cursorTop: 0,
      cursorLeft: 0,
    }
  },
  computed: {
    matrixValue(){
      const Result = this.config.matrix <= 16? 128:this.config.matrix
      return Result
    },
    matrixNumber(){
      const Result = this.$refs.panel.getBoundingClientRect().width/this.matrixValue
      return Result
    },
    colorValue(){
      return this.color
    }
  },
  watch: {
    colorValue(e) {
      if (!this.cxCyUtils) return
      const colorData = this.cxCyUtils.CxCy2XY(e)
      this.updateColor(colorData.xAxis, colorData.yAxis)
      const { cx, cy } = ValueToCxCy(Number(e))
      this.$emit('handlePanelColor', { cx, cy, value: Number(e) })
    },

    color(val) {
      // const colorData = this.cxCyUtils.CxCy2XY(val)
      // console.log('color color', val, colorData);
      // this.$emit('updateXy', colorData);
    }
  },
  mounted(){
    console.log('9991');
    let data = this.config
    console.log("🚀 ~ mounted ~ data:", this.image)
    data.matrix = this.matrixValue
    this.cxCyUtils = new CxCyUtils(data)
    draggable(this.$el, {
      drag: (event) => {
        this.handleDrag(event,false);
      },
      end: (event) => {
        this.handleDrag(event,true);
      }
    });
    const colorData = this.cxCyUtils.CxCy2XY(this.color)
    this.updateColor(colorData.xAxis,colorData.yAxis)

    let X = colorData.xAxis;
    let Y = this.matrixValue - 1 - colorData.yAxis;


    const errorArea = 118;
    if (X > errorArea || Y > errorArea) {
      const allList = [];
      const value = Number(this.color);
      if (value !== this.cxCyUtils.XY2CxCYValue(X, Y).value) {
        for (let i = errorArea + 1; i < this.matrixValue; i++) {
          for (let j = errorArea + 1; j < this.matrixValue; j++) {
            allList.push([i, j]);
          }
        }

        for (let i = 0; i < allList.length; i++) {
          const item = allList[i];
          if (this.cxCyUtils.XY2CxCYValue(item[0], item[1]).value === value) {
            X = item[0];
            Y = item[1];
            break;
          }
        }
        console.log('9994 又问题', X, Y)
      }
    }
    
    // console.log('9994',  this.cxCyUtils.XY2CxCYValue(X, Y))
    /* 
    * 适配第一象限坐标系
    * 减1是因为坐标取值范围是0-31
    */
    const gridData = this.cxCyUtils.XY2CxCYValue(X, Y)
    const { cx, cy } = ValueToCxCy(Number(this.color))
    this.$emit('handlePanelColor', { ...gridData, cx, cy })
  },
  methods:{
    handleDrag(event,canConfirm){
      const el = this.$el;
      const rect = el.getBoundingClientRect();
      let left = event.clientX - rect.left;
      let top = event.clientY - rect.top;
      left = Math.max(0, left);
      left = Math.min(left, rect.width);
      top = Math.max(0, top);
      top = Math.min(top, rect.height);
      this.cursorLeft = left.toFixed(0);
      this.cursorTop = top.toFixed(0);
      const colorX = (left/this.matrixNumber).toFixed(0)
      const colorY = ((rect.height-top)/this.matrixNumber).toFixed(0)
      
      this.$emit('handlePanelColor', this.cxCyUtils.XY2CxCYValue(colorX,colorY))
      if(canConfirm){
        this.$emit('confirmValue',this.cxCyUtils.XY2CxCYValue(colorX,colorY).value)
      }
    },
    handleColor(xAxis,yAxis){
      this.$emit('handlePanelColor', this.cxCyUtils.XY2CxCYValue(xAxis,yAxis))
      this.$emit('confirmValue',this.cxCyUtils.XY2CxCYValue(xAxis,yAxis).value)
    },
    updateColor(xAxis,yAxis){
      this.$nextTick(()=>{
        const el = this.$el;
        const rect = el.getBoundingClientRect();
        
        this.cursorLeft = Math.min(Math.max(0, xAxis * this.matrixNumber), rect.width);
        this.cursorTop = Math.min(Math.max(0, yAxis * this.matrixNumber), rect.height);

        this.$forceUpdate()
      })
    },
  }
}
</script>

<style lang="scss" scoped>

.color-panel::before{
  position: absolute;
  top: -60px;
  left: 50%;
  content: '';
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 10px 15px 10px; 
  border-color: transparent transparent #fff transparent; 
  transform: translate(-50% ,0);
}
.color-panel{
  position: relative;
  width: 256px;
  height:256px;
  z-index: 2000;
  border-radius: 5px;
  background-image: url('../image/colorPicker.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.cursor>div{
  cursor: head;
  width: 16px;
  height: 16px;
  box-shadow: 0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3), 0 0 1px 2px rgba(0,0,0,.4);
  border-radius: 50%;
  transform: translate(-8px,-8px);
}
.cursor{
  position: absolute;
}


</style>